"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildFileInfo = buildFileInfo;
exports.deleteOssFile = deleteOssFile;
exports.getFileNameFromUrl = getFileNameFromUrl;
exports.getOssPolicy = getOssPolicy;

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.split");

var _request = _interopRequireDefault(require("@/utils/request"));

/**
 * 获取 OSS 直传策略（Policy）
 * 后端返回 OSS 临时访问凭证及上传策略
 * @param {Object} params - 请求参数
 * @param {String} params.dir - 上传目录（可选，默认由后端决定）
 * @param {Number} params.expire - 过期时间（秒，可选）
 * @returns {Promise<Object>} 包含 accessKeyId, host, policy, signature, prefix, maxSize, expireSeconds 等字段
 */
function getOssPolicy(params) {
  return (0, _request.default)({
    url: '/api/oss/policy',
    method: 'get',
    params: params
  });
}
/**
 * OSS 文件删除接口
 * @param {Object} params - 请求参数
 * @param {String} params.fileName - 文件名
 * @param {String} params.dir - 文件所在目录
 * @returns {Promise}
 */


function deleteOssFile(params) {
  return (0, _request.default)({
    url: '/api/oss/delete',
    method: 'post',
    data: params
  });
}
/**
 * 从 OSS 返回的 URL 中提取文件名
 * @param {String} url - OSS 文件 URL
 * @returns {String} 文件名
 */


function getFileNameFromUrl(url) {
  if (!url) return '';
  var parts = url.split('/');
  return parts[parts.length - 1];
}
/**
 * 从 OSS 返回结果中构建完整文件信息
 * @param {Object} ossResult - OSS 上传返回结果
 * @param {String} host - OSS 域名
 * @returns {Object} 文件信息对象
 */


function buildFileInfo(ossResult, host) {
  var baseHost = host || ossResult.host || '';
  var fileUrl = ossResult.url || ossResult.fileUrl || "".concat(baseHost, "/").concat(ossResult.key);
  return {
    realName: ossResult.key || getFileNameFromUrl(fileUrl),
    url: fileUrl,
    type: ossResult.type || '',
    size: ossResult.size || 0,
    alias: ossResult.name || getFileNameFromUrl(fileUrl)
  };
}